class LoginController {
    static $inject = ['OidcService'];
    async siginRedirectAsync() {
        await this.OidcService.getInitializedPromise();
        const extraQueryParams = this.getQueryStringUtmsSegment();
        return this.OidcService.UserManager.signinRedirect({ extraQueryParams });
    }
    constructor(OidcService) {
        this.OidcService = OidcService;
        this.onlyUtmsSegment = key => /(utm_source|utm_medium|utm_campaign|utm_content|utm_term)/.test(key);
        this.generateParamsUtm = params => (utmProperties, key) => {
            utmProperties[key] = params[key];
            return utmProperties;
        };
        this.getQueryStringUtmsSegment = () => {
            try {
                const urlSearchParams = new URLSearchParams(location.search);
                const params = Object.fromEntries(urlSearchParams.entries());
                const utmsQueryString = Object.keys(params)
                    .filter(this.onlyUtmsSegment)
                    .reduce(this.generateParamsUtm(params), {});
                return utmsQueryString;
            }
            catch {
                return {};
            }
        };
        this.siginRedirectAsync();
    }
}
LoginController.$inject = ['OidcService'];
export default LoginController;
